(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
require('./plugins/slick');

var Theme = require('./modules/theme');
var Fund = require('./modules/fund');

jQuery(document).ready(function($) {
	Theme.init();
	Fund.init();
});

}).call(this,require("rH1JPG"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/fake_963b23bf.js","/")